import { render, staticRenderFns } from "./HotelCards.vue?vue&type=template&id=08314902&"
import script from "./HotelCards.vue?vue&type=script&lang=js&"
export * from "./HotelCards.vue?vue&type=script&lang=js&"
import style0 from "./HotelCards.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports